import React from 'react';
import { Router } from '@reach/router';

import Dashboard from './Dashboard';
import Order from './Order';
import Container from './Container';

export default () => (
  <Container>
    <Router>
      <Dashboard path="/*" />
      <Order path="order/*" />
    </Router>
  </Container>
);
